<template>
  <div class="merchant-list">
    <GlobalInfoBar
        title="商家列表"
        content="管理已合作的回收商家，查看或处理已发送的合作申请"
    />
    <GlobalChunkNo
        icon="search"
        title="筛选查询"
    >

      <div slot="filter">
        <Form />
      </div>

      <Table />
    </GlobalChunkNo>
  </div>
</template>

<script>
import Form from "./Form"
import Table from "./Table"
export default {
  name: 'merchant-list',
  components: {Form, Table},
  data(){
    return{
    }
  },
  methods:{
  },
}
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.merchant-list{
}
</style>
